import DialogContext, { openDialogProps } from '@Contexts/dialogContext';
import { LoadingButton } from '@mui/lab';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DialogProvider = ({ children }) => {
    const { t } = useTranslation('controls');
    const [props, setProps] = useState<openDialogProps | undefined>();
    const {
        title,
        cancelLabel,
        confirmLabel,
        onConfirm,
        message,
        content,
        confirmMutation,
        confirmButtonProps,
        dialogProps,
        disableActions,
    } = props || {};

    const handleOpen = setProps;
    const handleClose = () => setProps(undefined);

    return (
        <DialogContext.Provider
            value={{ open: handleOpen, close: handleClose }}
        >
            {children}
            <Dialog
                {...dialogProps}
                open={Boolean(props)}
                onClose={handleClose}
                disableRestoreFocus
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{message}</DialogContentText>
                    {content}
                </DialogContent>
                {!disableActions && (
                    <DialogActions>
                        <Button
                            variant="text"
                            color="secondary"
                            onClick={handleClose}
                        >
                            {cancelLabel || t('Cancel')}
                        </Button>
                        {confirmMutation ? (
                            <LoadingButton
                                variant="text"
                                onClick={() =>
                                    confirmMutation.mutate(onConfirm?.())
                                }
                                loading={confirmMutation.isPending}
                                {...confirmButtonProps}
                            >
                                {confirmLabel}
                            </LoadingButton>
                        ) : (
                            <Button
                                variant="text"
                                onClick={onConfirm}
                                {...confirmButtonProps}
                            >
                                {confirmLabel}
                            </Button>
                        )}
                    </DialogActions>
                )}
            </Dialog>
        </DialogContext.Provider>
    );
};

export default DialogProvider;
